const clinicType = 'vet';
const isProd = process.env.REACT_APP_USER_API_URL.includes('prod');

const pricingDetails = {
    vet: {
        Student: {
            accountType: 'Student',
            productId: isProd ? 'prod_QjtOG8QIilyVNr' : 'prod_QXpfPHjuwthNx7',
            priceMonthlyId: isProd ? 'price_1R3uGcL2Uy8HcDMu9sPsymmb' : 'price_1QpDdKL2Uy8HcDMukMb7it5E',
            priceMonthly: 4.99,
            priceAnnually: 56.88,
            priceAnnuallyId: isProd ? 'price_1SLghQL2Uy8HcDMuHQlTrQiR' : 'price_1SLgf9L2Uy8HcDMuRiEDhFFz',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View all anatomy diagrams',
                'Basic customer support',
                'Interactive whiteboard',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'R2gDZ3',
        },
        Professional: {
            accountType: 'Professional',
            productId: isProd ? 'prod_QjtJiFdck0KupJ' : 'prod_QXpfh4Pw3WYGiz',
            priceMonthlyId: isProd ? 'price_1R3uJmL2Uy8HcDMu38y3aLAB' : 'price_1QpDg3L2Uy8HcDMubCIaJMFf',
            priceMonthly: 9.99,
            priceAnnually: 113.88,
            priceAnnuallyId: isProd ? 'price_1R3uK8L2Uy8HcDMupfKXnrP0' : 'price_1QpDjqL2Uy8HcDMuGAM33XUk',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View all anatomy diagrams',
                'Unlimited digital sharing',
                'Clinic name on all handouts',
                'Interactive 3D models',
                'Basic customer support',
                'Interactive whiteboard',
                'Whiteboard client library',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'Y7kVFz',
        },
        'Professional - 14 day FREE trial': {
            accountType: 'Professional',
            productId: 'trial',
            priceMonthlyId: 'trial',
            priceMonthly: 0,
            priceAnnually: 0,
            priceAnnuallyId: 'trial',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View all anatomy diagrams',
                'Unlimited digital sharing',
                'Clinic name on all handouts',
                'Interactive 3D models',
                'Basic customer support',
                'Interactive whiteboard',
                'Whiteboard client library',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'XJsU8z',
        },
        Clinic: {
            accountType: 'Clinic',
            productId: isProd ? 'prod_QjtOpkXwFHjj9x' : 'prod_QXpg8C1N3zC1Xg',
            priceMonthlyId: isProd ? 'price_1R3u6TL2Uy8HcDMuA7XRseGI' : 'price_1QpDiAL2Uy8HcDMuWBw3FHhr',
            priceMonthly: 49.99,
            priceAnnually: 569.88,
            priceAnnuallyId: isProd ? 'price_1R3u7kL2Uy8HcDMuVn3RkcmJ' : 'price_1QpDiaL2Uy8HcDMu9yaaG4ZW',
            benefits: [
                'Multi user access - up to 5 users',
                'View all information handouts',
                'View all anatomy diagrams',
                'Unlimited digital sharing',
                'Ability to bundle handouts',
                'Custom branding on handouts',
                'Interactive 3D models',
                'Premium customer support',
                'Interactive whiteboard',
                'Whiteboard client library',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'SDs2NJ',
        },
        Enterprise: {
            countType: 'Enterprise',
            benefits: [
                'Multi-user access – more than 5 users',
                'Multi-clinic access',
                'Shared content libraries',
                'View all information handouts',
                'View all anatomy diagrams',
                'Unlimited digital sharing',
                'Ability to bundle handouts',
                'Custom branding on handouts',
                'Interactive 3D models',
                'Premium customer support',
                'Interactive whiteboard',
                'Whiteboard client library',
            ],
            description:
                'Our enterprise plan is designed for larger organisations. This plan has advanced administrative and reporting functions, and is a cost effective option for institutions and businesses with multiple clinics or more than 5 users.',
            klaviyoListId: 'XJsU8z', //TODO it needs a new klaviyo list
        },
    },
};

module.exports = pricingDetails[clinicType];
